import React from 'react';

const BonusIcon = ({ fill, width, height, opacity }) => (
    <svg className="icon icon-bonus" width={width} height={height} viewBox="0 0 24 24">
        <path
            fill={fill}
            opacity={opacity}
            d="M19.064 3c.322 0 .625.125.818.337l3.914 4.311a.73.73 0 0 1-.002 1.014L12.815 20.665a.954.954 0 0 1-.2.165 1.162 1.162 0 0 1-.746.162 1.076 1.076 0 0 1-.684-.327L.206 8.662a.73.73 0 0 1-.002-1.014l3.914-4.31c.193-.213.496-.338.818-.338zM16.33 8.727H7.668L12 18.845l4.33-10.118zm-10.281.001-3.864-.001 7.259 7.937-3.379-7.895a.825.825 0 0 1-.016-.041zm15.764-.001h-3.865l-.013.042-3.38 7.893 7.258-7.935zM7.711 4.265h-2.52L2.253 7.5h4.082l1.375-3.234zm6.988.074H9.3l-1.344 3.16h8.086l-1.343-3.16zm4.11-.074h-2.521l1.375 3.234h4.081l-2.935-3.234z"
            fillRule="evenodd"
        />
    </svg>
);

export default BonusIcon;
